import { Popover } from "@headlessui/react";
import React from "react";
import {
  OpenAmendmentAdminCompletedButton,
  ReportRegeneratePDFAdminCompletedButton,
  ReportRerunPersonPDFAdminCompletedButton,
} from "../admin/admin-completed/TableAdminCompletedButtons";
import ElipseIcon from "../shared-components/icons/ElipseIcon";
import { useReportByUUID } from "../api/ReportsApi";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import SkeletonSpacer from "../shared-components/SkeletonSpacer";

interface PopMenuProps {
  reportUUID: string;
}

export function ThreeSixtyActionFinishedActionMenu({
  reportUUID,
}: PopMenuProps) {
  const { canRegeneratePDF, canRerunReport, canAmend } =
    usePermissionValidator();
  const {
    data: report,
    mutate: reportGet,
    isLoading: isReportLoading,
    isError: isReportError,
  } = useReportByUUID();
  const hasAvailableActions = canRegeneratePDF || canRerunReport || canAmend;

  function handleMenuOpen() {
    if (canRerunReport) {
      reportGet(reportUUID);
    }
  }

  return (
    <Popover className="relative">
      {({ close }) => (
        <>
          <Popover.Button className="outline-none" onClick={handleMenuOpen}>
            <ElipseIcon />
          </Popover.Button>

          <Popover.Panel className="absolute z-50 shadow-lg right-1 top-7 border">
            <div className="min-w-[240px] bg-white p-2 flex flex-col gap-1">
              {canRegeneratePDF && (
                <ReportRegeneratePDFAdminCompletedButton
                  text="Regenerate PDF"
                  reportUUID={reportUUID}
                  close={close}
                />
              )}
              {canRerunReport && (
                <>
                  {isReportLoading && (
                    <div className="overflow-hidden w-full h-6">
                      <SkeletonSpacer />
                    </div>
                  )}
                  {!isReportLoading && report && (
                    <ReportRerunPersonPDFAdminCompletedButton
                      text="Rerun Person"
                      report={report}
                      close={close}
                    />
                  )}
                  {!isReportLoading && isReportError && (
                    <button
                      type="button"
                      className="rounded-md p-1 text-left text-sm text-red-600 hover:bg-gray-100"
                      onClick={handleMenuOpen}
                    >
                      Unable to load rerun data. Retry.
                    </button>
                  )}
                </>
              )}

              {canAmend && (
                <OpenAmendmentAdminCompletedButton
                  text="Open Amendment"
                  reportUUID={reportUUID}
                  close={close}
                />
              )}
              {!hasAvailableActions && (
                <div className="rounded-md p-1 text-sm text-gray-500">
                  No actions available
                </div>
              )}
            </div>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}

export default ThreeSixtyActionFinishedActionMenu;
